<template>
	<span class='stars'>
		<span v-for='i in fullStar'>
			<img @click='clickFull(i)' src='../../static/components/stars/star_full.png'>
		</span>
		<span v-if='hasHalfStar'>
			<img src='../../static/components/stars/star_half.png'>
		</span>
		<span v-for='i in nullStar'>
			<img @click='clickEmpty(i)' src='../../static/components/stars/star_empty.png'>
		</span>
	</span>
</template>

<script>
export default {
  data () {
    return {
			
    }
  },
	props: {
		//分数
    score: {
      type: Number,
      default: '5',
    },
		//激活评分功能
		canChoose:{
			type: Boolean,
			default: false
		}
  },
	methods: {
		clickEmpty(val){
			if(this.canChoose){
				var number = val + this.fullStar
				this.$emit('select',number)
			}
		},
		clickFull(val){
			if(this.canChoose){
				var number = val
				this.$emit('select',number)
			}
		}
	},
	computed: {
		//整个星星个数
		fullStar() {
      return Math.floor(this.score);
    },
		//空白星星个数
    nullStar() {
      return Math.floor(5 - this.score);
    },
		//是否有半个星星
    hasHalfStar() {
      if (Math.floor(this.score) == this.score) {
        return false;
      }
      return true;
    },
	}
}
</script>

<style lang="less" scoped>
	@import "../assets/theme.less";
	.stars{
		display:inline-flex;
		justify-content:center;
		margin:0;
		span{
			width:0.8em;
			height:auto;
		}
		img{
			width:0.8em;
		}
		
	}
</style>


// WEBPACK FOOTER //
// stars.vue?c50a7f8c